import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { paths } from '../navigation/paths';
import { RuleSections } from '../components/RuleSections';
import { rulesToMarkdown } from '../utils/ruleMarkdown';

export function LandingPage() {
  const navigate = useNavigate();
  const { showRules, setShowRules, rules } = useApp();

  return (
    <div className="landing-page-epic">
      <nav className="sticky-nav">
        <div className="nav-brand">
          <span className="nav-icon">🐉</span>
          <span className="nav-title">Ralfs Abenteuer</span>
        </div>
        <div className="nav-buttons">
          <button className="nav-btn player-btn" aria-label="Spieler" onClick={() => navigate(paths.play)}>
            <span className="btn-icon" aria-hidden>⚔️</span>
            <span className="btn-label">Spieler</span>
          </button>
          <button className="nav-btn admin-btn" aria-label="Spielleiter" onClick={() => navigate(paths.login)}>
            <span className="btn-icon" aria-hidden>👑</span>
            <span className="btn-label">Spielleiter</span>
          </button>
        </div>
      </nav>

      <section className="epic-hero">
        <div className="hero-overlay"></div>
        <div className="floating-particles">
          <span className="particle">✨</span>
          <span className="particle">⚔️</span>
          <span className="particle">🛡️</span>
          <span className="particle">🔮</span>
          <span className="particle">🏰</span>
          <span className="particle">🐲</span>
        </div>
        <div className="hero-content">
          <div className="crown-ornament">👑</div>
          <h1 className="epic-title">
            <span className="title-line">⚔️ RALFS ⚔️</span>
            <span className="title-main">ABENTEUER</span>
            <span className="title-sub">Das epische Fantasy-Brettspiel</span>
          </h1>
          <p className="epic-tagline">
            Betritt eine Welt voller Drachen, Magie und legendärer Quests
          </p>
          <div className="hero-cta">
            <button className="cta-button primary" onClick={() => navigate(paths.play)}>
              <span className="cta-icon">⚔️</span>
              Abenteuer beginnen
            </button>
          </div>
        </div>
        <div className="scroll-indicator">
          <span className="scroll-arrow">▼</span>
          <span className="scroll-text">Mehr erfahren</span>
        </div>
      </section>

      <section className="features-section">
        <div className="section-header">
          <div className="header-ornament">═══════ ✦ ═══════</div>
          <h2>Was erwartet dich?</h2>
          <div className="header-ornament">═══════ ✦ ═══════</div>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⚔️</div>
            <h3>Epische Kämpfe</h3>
            <p>Führe deine Helden in taktische Schlachten gegen furchterregende Monster und rivalisierende Krieger.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧙</div>
            <h3>Magie & Zauber</h3>
            <p>Beherrsche mächtige Zaubersprüche und setze magische Artefakte ein, um deine Feinde zu besiegen.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏰</div>
            <h3>Quests & Abenteuer</h3>
            <p>Erkunde geheimnisvolle Dungeons, antike Ruinen und gefährliche Wälder auf der Suche nach Schätzen.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>2-6 Helden</h3>
            <p>Verbünde dich mit deinen Freunden und bildet eine legendäre Heldengruppe.</p>
          </div>
        </div>
      </section>

      <section className="rules-section-epic">
        <div className="section-header">
          <div className="header-ornament">═══════ ✦ ═══════</div>
          <h2>📜 Die Regeln des Reiches</h2>
          <div className="header-ornament">═══════ ✦ ═══════</div>
        </div>
        <button className="rules-toggle-btn" onClick={() => setShowRules(!showRules)}>
          {showRules ? '🔒 Regeln verbergen' : '📖 Regeln enthüllen'}
        </button>
        {showRules && (
          <div className="rules-scroll">
            <RuleSections markdown={rulesToMarkdown(rules)} emptyText="Keine Regeln verfügbar" />
          </div>
        )}
      </section>

      <section className="cta-footer">
        <div className="cta-content">
          <h2>Bereit für das Abenteuer?</h2>
          <p>Wähle deine Rolle und betritt die Welt von Ralfs Abenteuer!</p>
          <div className="cta-buttons">
            <button className="big-cta player" onClick={() => navigate(paths.play)}>
              <span className="cta-big-icon">⚔️</span>
              <span className="cta-big-title">Als Spieler</span>
              <span className="cta-big-sub">Werde ein Held</span>
            </button>
            <button className="big-cta admin" onClick={() => navigate(paths.login)}>
              <span className="cta-big-icon">👑</span>
              <span className="cta-big-title">Als Spielleiter</span>
              <span className="cta-big-sub">Leite das Abenteuer</span>
            </button>
          </div>
        </div>
        <div className="footer-ornament">═══════════════ 🐉 ═══════════════</div>
      </section>
    </div>
  );
}
